import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import LogoImage from "../../images/aadi0info-logo.png";
import LogoImage1 from "../../images/phone.svg";
import LogoImage2 from "../../images/mail.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram.svg";

const Container = tw.div`relative bg-gray-200 text-gray-700  px-0 py-0 mt-8 lg:py-6 overflow-hidden`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/4 md:w-auto mt-12  `;

const ColumnHeading = tw.h5`uppercase font-bold `;

const LinkList = tw.ul`mt-4 text-sm font-medium text-center gap-4 `;
const LinkListItem = tw.li`mt-2`;
const Link = tw.a`border-b-2  border-transparent hocus:border-gray-700 pb-1 transition duration-300`;

const Divider = tw.div`my-4 border-b-2 border-gray-400 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between mb-2`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start gap-1 mb-2`;
const LogoImg = tw.img`w-64`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-4 md:mt-0 font-medium text-gray-500`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <Container>
      <Content>
        <SixColumns>
          <Column>
            <LogoContainer>
              <LogoImg src={LogoImage} tw="mt-3"/>
              {/* <LogoText tw="text-blue-800">Aadi Info Solutions</LogoText> */}
            </LogoContainer>
          </Column>

          <Column>
            <ColumnHeading>Quick Links</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#home">Home</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#about">About Us</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#services">Services</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#contactus">Contact</Link>
              </LinkListItem>
            </LinkList>
          </Column>

          <Column>
            <div>
              <h3 tw="uppercase font-bold  mb-3">Contact Details</h3>

              <div tw="flex flex-col gap-3">
                <h3 tw="mb-4">
                  <LogoContainer>
                    <LogoImg
                      src={LogoImage2}
                      tw="w-6"
                      onClick={() =>
                        window.open(
                          "https://mail.google.com/mail/?view=cm&to=hr_india@aadiinfosolutions.com",
                          "_blank"
                        )
                      }
                    />

                    <Link>hr_india@aadiinfosolutions.com</Link>
                  </LogoContainer>
                </h3>
                <h3 tw="mb-4">
                  <LogoContainer>
                    <LogoImg
                      src={LogoImage1}
                      tw="w-6"
                      onClick={() =>
                        (window.location.href = "tel:+919482138457")
                      }
                    />
                    <Link>+91 9482138457</Link>
                  </LogoContainer>
                </h3>
              </div>
            </div>
          </Column>
        </SixColumns>
        <Divider />
        <ThreeColRow>
          <CopywrightNotice>
            &copy; {year} Aadi Info Solutions. All Rights Reserved.
          </CopywrightNotice>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com" target="_blank">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com" target="_blank">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://youtube.com" target="_blank">
              <YoutubeIcon />
            </SocialLink>
            <SocialLink href="https://instagram.com" target="_blank">
              <InstagramIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
    </Container>
  );
};
